// src/pages/Invoices.js
import React, { useEffect, useState, useCallback } from 'react';
import { getInvoices, sendInvoice, downloadInvoicePDF, saveBlob } from '../services/api';
import { useAuth } from '../context/AuthContext';
import { T, fmt, Badge, Card, Btn, Empty, Spinner, SectionTitle, TH, TD, InfoBox } from '../components/UI';

export default function Invoices() {
  const { can } = useAuth();
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading]   = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try { const r = await getInvoices(); setInvoices(r.data.data); }
    catch(e) { console.error(e); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const handleSend = async (id) => {
    try { await sendInvoice(id); await load(); }
    catch(e) { alert(e.response?.data?.message || 'Failed'); }
  };

  const handleDownload = async (inv) => {
    try {
      const res = await downloadInvoicePDF(inv.id);
      saveBlob(res.data, `${inv.invoice_number}.pdf`);
    } catch (e) {
      alert(e.response?.data?.message || 'Download failed. Please try again.');
    }
  };

  if (loading) return <Spinner />;

  return (
    <div>
      <SectionTitle sub="Auto-generated on order creation · Managed by Bett">Invoice System</SectionTitle>
      {!can('send_invoice') && <InfoBox>ℹ Invoice actions are managed by Bett.</InfoBox>}
      <Card>
        {invoices.length === 0 ? <Empty msg="No invoices yet. Create an order first." /> : (
          <table style={{ width:'100%', borderCollapse:'collapse' }}>
            <thead><tr>
              <th style={TH}>Invoice</th><th style={TH}>Order</th><th style={TH}>Customer</th><th style={TH}>Amount</th><th style={TH}>Paid</th><th style={TH}>Status</th><th style={TH}>Actions</th>
            </tr></thead>
            <tbody>
              {invoices.map(inv => (
                <tr key={inv.id}>
                  <td style={{ ...TD, color:T.info, fontWeight:700 }}>{inv.invoice_number}</td>
                  <td style={{ ...TD, color:T.gold }}>{inv.order_number}</td>
                  <td style={TD}>{inv.customer_name}</td>
                  <td style={{ ...TD, fontWeight:600 }}>{fmt(inv.total_amount)}</td>
                  <td style={{ ...TD, color:T.success }}>{fmt(inv.amount_paid)}</td>
                  <td style={TD}><Badge status={inv.status} /></td>
                  <td style={{ ...TD }}>
                    <div style={{ display:'flex', gap:'6px', flexWrap:'wrap' }}>
                      {can('send_invoice') && inv.status === 'UNPAID' && (
                        <Btn size="sm" onClick={() => handleSend(inv.id)}>📤 Send</Btn>
                      )}
                      <button onClick={() => handleDownload(inv)}
                        style={{ background:T.info, color:'#fff', border:'none', borderRadius:'6px', padding:'5px 12px', fontSize:'12px', fontWeight:700, cursor:'pointer' }}>
                        ⬇ PDF
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </Card>
    </div>
  );
}
